import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_left_bottom",
  "use": "icon-arrow_left_bottom-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_left_bottom\">\r\n<path d=\"M16 6.00003L8.02228 14V7.00001C8.02228 6.44264 7.56494 6.00001 7.00756 6.00001C6.45019 6.00001 6 6.44264 6 7.00001V17C6 17.5574 6.45019 18 7.00756 18H16.5C17.0574 18 17.5 17.5574 17.5 17C17.5 16.4426 17.0574 16 16.5 16H9L17.5 7.50001C17.893 7.10699 17.893 6.39302 17.5 6C17.107 5.60698 16.393 5.60701 16 6.00003Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol